var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.src)?_c('div',{staticClass:"iframe__wrapper",style:(_vm.iframeWrapperStyles)},[_c('iframe',_vm._b({class:_vm.iframeDynamicClass,attrs:{"src":_vm.iframeSrc}},'iframe',_vm.iframeAttrs,false))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }